import { contains } from './contains';

/**
 * Method that checks whether cls is present in element object. (Will set class attribute to empty if not present).
 * @param  {Object} ele DOM element which needs to be checked
 * @param  {Object} cls Classname is tested
 * @return {Boolean} True if cls is present, false otherwise.
 */
export const hasClass = (ele, cls) => {
    if (ele.classList) {
        return ele.classList.contains(cls);
    } else {
        if (!ele.hasAttribute('class')) {
            return false;
        }
        return ele.getAttribute('class').indexOf(cls) > -1;
    }
};

/**
 * Method that adds a class to given element.
 * @param  {Object} ele DOM element where class needs to be added
 * @param  {Object} cls Classname which is to be added
 * @return {null} nothing is returned.
 */
export const addClass = (ele, cls) => {
    if (ele.classList) {
        if (contains(cls, ' ')) {
            let clsArr = cls.split(' ');
            for (let i = 0; i < clsArr.length; i++) {
                ele.classList.add(clsArr[i]);
            }
        } else {
            ele.classList.add(cls);
        }
    } else if (!hasClass(ele, cls)) {
        ele.setAttribute('class', ele.getAttribute('class') + ' ' + cls);
    }
};

/**
 * Method that does a check to ensure that class is removed from element.
 * @param  {Object} ele DOM element where class needs to be removed
 * @param  {Object} cls Classname which is to be removed
 * @return {null} Null nothing is returned.
 */
export const removeClass = (ele, cls) => {
    if (ele.classList) {
        ele.classList.remove(cls);
    } else if (hasClass(ele, cls)) {
        ele.setAttribute('class', ele.getAttribute('class').replace(cls, ' '));
    }
};

/**
 * Toggles specified classes on the passed element
 * @param  {Object} ele DOM element where class needs to be removed
 * @param  {Object} cls Classname which is to be removed
 * @return {null} Null nothing is returned.
 */
export const toggleClass = (ele, cls) => {
    if (ele.classList) {
        ele.classList.toggle(cls);
    } else {
        if (hasClass(ele, cls)) {
            removeClass(ele, cls);
        } else {
            addClass(ele, cls);
        }
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/helpers/class-list.js